<template>
  <div class="overview">
    <Header ref="Header" title="交易数据" :hasDate="true" :hasPicker="true" @refreshheader="getTableData"/>
    <div class="overview__row" flex="box:mean">
      <div class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">总交易额</div>
        <div>￥{{order_amount}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">总交笔数</div>
        <div>{{order_num}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">退款金额</div>
        <div>￥{{refund_amount}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">退款笔数</div>
        <div>{{refund_num}}</div>
      </div>
      <div class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">实际营收</div>
        <div>￥{{yx_order_amount}}</div>
      </div>
      <div v-if="dl_type!='4'"  class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">我的佣金</div>
        ￥{{serve_agent_amt}}
      </div>
      <div v-if="dl_type=='4'" class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">支付宝交易笔数</div>
        {{zfb_num}}
      </div>
      <div v-if="dl_type=='4'" class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">微信支付交易笔数</div>
        {{wx_num}}
      </div>
      <div v-if="dl_type=='4'"  class="overview__col" flex="dir:top cross:center">
        <div class="overview__title">其他支付交易笔数</div>
        {{wz_num}}
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../Header'
import util from '@/libs/util.js'
import * as agentService from '@/api/sys/agent'
export default {
  components: { 'Header': Header },
  name: 'OverView',

  data () {
    return {
      order_amount: '',
      order_num: '',
      refund_amount: '',
      refund_num: '',
      yx_order_amount: '',
      serve_agent_amt: '',
      zfb_num: '',
      wx_num: '',
      wz_num: '',
      dl_type: util.cookies.get('dl_type')

    }
  },

  created () {
    this.chartData = {
      columns: ['test', '我的佣金', '利润', '占比', '其他', '我的佣金'],
      rows: [
        { 日期: '1月1日', 成本: 1523, 利润: 1523, 占比: 0.12, 其他: 100 },
        { 日期: '1月2日', 成本: 1223, 利润: 1523, 占比: 0.345, 其他: 100 },
        { 日期: '1月3日', 成本: 2123, 利润: 1523, 占比: 0.7, 其他: 100 },
        { 日期: '1月4日', 成本: 4123, 利润: 1523, 占比: 0.31, 其他: 100 }
      ]
    }
    this.chartSettings = {}
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    dateConversion (value) {
      var d = new Date(value)
      //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
      var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      console.info('===========date=========' + date)
      return date
    },
    getTableData () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', util.cookies.get('agentid'))
      formData4.append('start_time', this.dateConversion(this.$refs.Header.pickerValue[0]))
      formData4.append('end_time', this.dateConversion(this.$refs.Header.pickerValue[1]))
      formData4.append('dl_type', util.cookies.get('dl_type'))
      formData4.append('xt_id', util.cookies.get('xt_id'))
      agentService.getStatisticsHome(formData4).then(data => {
        if (data != null && data != '') {
          this.order_amount = data.order_amount
          this.order_num = data.order_num
          this.refund_amount = data.refund_amount
          this.refund_num = data.refund_num
          this.yx_order_amount = data.yx_order_amount
          this.serve_agent_amt = data.serve_agent_amt
          this.zfb_num = data.zfb_num
          this.wx_num = data.wx_num
          this.wz_num = data.wz_num
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.overview {
  width: 100%;
  border-radius: 10px;
  height: 1.4rem;
  min-height: 130px;
  &__col {
    font-size: 0.15rem;
    margin-top: 15px;
  }
  &__col:not(:last-child) {
    border-right: 1px solid rgb(242, 242, 242);
  }
  &__title {
    color: rgb(137, 149, 160);
    margin-bottom: 10px;
  }
}
</style>
